import React, { useState } from 'react';
import './StupidSystemDesigns.css';

const getRandomPrice = () => Math.floor(Math.random() * 10) + 1;

const designIdeas = [
    {
        id: 'splitwise-design',
        title: 'Splitwise',
        price: getRandomPrice(),
    },
    {
        id: 'file-system-design',
        title: 'File System',
        price: getRandomPrice(),
    },
    {
        id: 'rate-limiter-design',
        title: 'Rate Limiter',
        price: getRandomPrice(),
    },
    {
        id: 'paste-bin-design',
        title: 'PasteBin',
        price: getRandomPrice(),
    },
    {
        id: 'slot-bookings-design',
        title: 'Slot Bookings',
        price: getRandomPrice(),
    },
    {
        id: 'parking-garage',
        title: 'Parking Lot',
        price: getRandomPrice(),
    },
    {
        id: 'cache-design',
        title: 'Cache',
        price: getRandomPrice(),
    },
    {
        id: 'atm-design',
        title: 'ATM',
        price: getRandomPrice(),
    },
    {
        id: 'vending-machine-design',
        title: 'Vending Machine',
        price: getRandomPrice(),
    },
    {
        id: 'elevator-design',
        title: 'Elevator',
        price: getRandomPrice(),
    },
    {
        id: 'hashset-design',
        title: 'HashSet',
        price: getRandomPrice(),
    },
    {
        id: 'elasticsearch-design',
        title: 'Elasticsearch',
        price: getRandomPrice(),
    },
    {
        id: 'amazon-locker-design',
        title: 'Amazon Locker',
        price: getRandomPrice(),
    },
    {
        id: 'event-scheduler-design',
        title: 'Event Scheduler',
        price: getRandomPrice(),
    },
    {
        id: 'uber-design',
        title: 'Uber',
        price: getRandomPrice(),
    },
    {
        id: 'games-design',
        title: 'Games',
        price: getRandomPrice(),
    },
    {
        id: 'battleship-design',
        title: 'Battleship',
        price: getRandomPrice(),
    },
    {
        id: 'inventory-packing-design',
        title: 'Inventory Packing',
        price: getRandomPrice(),
    },
    {
        id: 'spell-checker-design',
        title: 'Spell Checker',
        price: getRandomPrice(),
    },
    {
        id: 'friend-recommender-design',
        title: 'Friend Recommender',
        price: getRandomPrice(),
    },
    {
        id: 'maze-solver-design',
        title: 'Maze Solver & Route Planner',
        price: getRandomPrice(),
    },
    {
        id: 'task-scheduler-design',
        title: 'Task Scheduler',
        price: getRandomPrice(),
    },
];

const formatPrice = (value) => {
    return Number(value).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
    });
};

function StupidSystemDesigns({ theme, onBackClick, onOpenDesign, onAddToCart }) {
    const [quantityById, setQuantityById] = useState({});
    const [cartMessage, setCartMessage] = useState('');
    const [justAddedId, setJustAddedId] = useState(null);

    const handleAddToCart = (design, quantity) => {
        if (!onAddToCart) return;

        const normalizedQuantity = Math.max(1, Number(quantity) || 1);
        const product = {
            id: design.id,
            name: design.title,
            desc: '',
            img: '',
            price: Number(design.price) || 0,
        };

        onAddToCart(product, normalizedQuantity);
        setQuantityById((prev) => ({ ...prev, [design.id]: 1 }));
        setJustAddedId(design.id);
        setCartMessage(`Added ${normalizedQuantity} × ${design.title} to the cart.`);
        window.setTimeout(() => {
            setJustAddedId(null);
            setCartMessage('');
        }, 1400);
    };

    return (
        <div className={`app ${theme}`}>
            <main>
                <section className="system-designs-header-section">
                    <div className="system-designs-header">
                        <div>
                            <h1>Stupid System Designs</h1>
                            <p className="system-designs-subtitle">
                                <i>For the software architects who want to see how NOT to design systems. </i><br></br>
                                Its just some low level design bro, what could go wrong? <br></br>
                            </p>
                        </div>
                        <button className="back-btn" onClick={onBackClick}>
                            Back to Home
                        </button>
                    </div>
                </section>

                {cartMessage && (
                    <div className="cart-feedback">{cartMessage}</div>
                )}

                <section className="system-designs-content">
                    <div className="system-designs-grid">
                        {designIdeas.map((design) => (
                            <article key={design.id} className="system-design-card">
                                <button
                                    type="button"
                                    className="system-design-link"
                                    onClick={() => onOpenDesign?.(design.id)}
                                >
                                    {design.title}
                                </button>
                                <div className="product-footer">
                                    <span className="product-price">{formatPrice(design.price)}</span>
                                    <div className="product-actions">
                                        <label className="qty-label">
                                            Qty
                                            <input
                                                type="number"
                                                min="1"
                                                value={quantityById[design.id] ?? 1}
                                                onChange={(event) => {
                                                    const nextValue = Math.max(1, Number(event.target.value) || 1);
                                                    setQuantityById((prev) => ({ ...prev, [design.id]: nextValue }));
                                                }}
                                            />
                                        </label>
                                        <button
                                            type="button"
                                            className={`add-cart-btn ${justAddedId === design.id ? 'added' : ''}`}
                                            onClick={() => handleAddToCart(design, quantityById[design.id] ?? 1)}
                                        >
                                            {justAddedId === design.id ? 'Added to cart' : 'Add to Cart'}
                                        </button>
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>

                    <div className="system-designs-footer-note">
                        Each concept is a future system-design page waiting for its own extravagant failure mode.
                    </div>

                    <button className="back-btn" onClick={onBackClick}>
                        Back to Home
                    </button>
                </section>
            </main>

            <footer className="footer">
                <p>© 2026 StupidDesigns.com. All rights reserved. Not that anyone actually wants them.</p>
            </footer>
        </div>
    );
}

export default StupidSystemDesigns;
